import * as React from "react"
import { useTheme } from "styled-components"
import { t } from "ttag"
import { BaseProps, Icon } from "@humanpredictiveintelligence/myqvt-library"

import * as Styles from "./DataAnonymizationIllustration.styles"

export const DataAnonymizationIllustration: React.FC<BaseProps> = props => {
  const theme = useTheme()

  return (
    <Styles.Container className={props.className}>
      <Icon name="lock" size={48} color={theme.colors.blackLight} />
      <Styles.Label>{t`Data anonymization\n in progress`}</Styles.Label>
    </Styles.Container>
  )
}
